/**
 * Returns the fully qualified site base url
 */

const ROOT = '/watch';

export default function getSiteUrlForPath(pathArg = '') {
    // prepend a slash if the path doesn't have it
    const path = (pathArg.indexOf('/') === 0) ? pathArg : `/${pathArg}`;
    let url = path;
    if (window) {
        const { location: { hostname, port, protocol } } = window;
        url = `${protocol}//${hostname}${port ? `:${port}` : port}${ROOT}${path}`;
    }
    return url;
}



// WEBPACK FOOTER //
// ./app/lib/format/getSiteUrlForPath.js